module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-intro-card1.1.82d9c76f.jpg";